type SharedSpacesRoute = {
  meta: Record<string, unknown>;
};

export function routeRequiresSharedSpaces(route: SharedSpacesRoute): boolean {
  return route.meta.requiresSharedSpaces === true;
}

export function sharedSpacesDisabledRedirect(): string {
  return "/u/workspaces";
}
